import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function Privacy() {
  const [s, setS] = useState(null);
  useEffect(() => {
    document.title = "Política de privacidade | Gran Hotel Sé";
    api.get("/content").then((r) => setS(r.data.settings)).catch(() => setS({}));
  }, []);

  return (
    <div className="min-h-screen bg-[#08080A] text-[#FAFAFA]" data-testid="privacy-page">
      <div className="mx-auto max-w-3xl px-6 py-16 sm:py-24">
        <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#A1A1AA] hover:text-white" data-testid="privacy-back-link">
          <ArrowLeft className="w-4 h-4" strokeWidth={1.2} /> Voltar ao site
        </Link>
        <img src="/logo.png" alt="Gran Hotel Sé" className="h-12 w-auto mt-12" />
        <h1 className="font-display text-4xl sm:text-5xl mt-12">Política de privacidade</h1>
        <div className="mt-6 h-px w-16 bg-[#CBD5E1]/60" />
        <p className="mt-8 text-[#D4D4D8] leading-relaxed whitespace-pre-line" data-testid="privacy-text">{s?.privacy_text}</p>
      </div>
    </div>
  );
}
